// extracted by mini-css-extract-plugin
module.exports = {"active-category":"sideMenu_active-category__1h0gx","category":"sideMenu_category__3lRc8"};